
import HowItWorksHero from '@/components/hero-section-info';
import HowItWorksStatement from '@/components/page-specific/how-it-works/statement';
import HowItWorksSection from '@/components/page-specific/how-it-works/section';
import HowItWorksFooter from '@/components/page-specific/how-it-works/footer';
import HowItWorksNote from '@/components/page-specific/how-it-works/note';
import {
  HeroColorScheme,
  HeroSectionEvent,
} from '@/components/page-specific/how-it-works/enums';
import { loadPageData } from '@/utils/prismic';
import routes from '@/constants/routes';
import headMeta from '@/constants/headMeta';
import UserSelectionStoreName from '@/store/user-selection/name';
import useCanonicalHead from '@/mixins/useCanonicalHead';

const ALL_PROVINCES_VIEW = 'ALL';
const schema = {
  meta: {
    type: 'Object',
    title: {
      type: 'String',
    },
    description: {
      type: 'String',
    },
  },
  header: {
    type: 'Object',
    required: true,
    title: {
      type: 'String',
    },
    description: {
      type: 'String',
    },
    button: {
      type: 'String',
    },
    link: {
      type: 'String',
    },
    image: {
      type: 'Object',
      subtype: 'image',
    },
  },
  statement: {
    type: 'Object',
    required: true,
    title: {
      type: 'String',
    },
    description: {
      type: 'String',
    },
  },
  sections: {
    type: 'Array',
    subtype: 'slice',
    province: {
      type: 'String',
    },
    title: {
      type: 'String',
    },
    description: {
      type: 'String',
    },
    items: {
      type: 'Array',
    },
    attachment: {
      type: 'Object',
    },
    caption: {
      type: 'String',
    },
    link: {
      type: 'String',
    },
    href: {
      type: 'String',
    },
  },
  footer: {
    type: 'Object',
    required: true,
    title: {
      type: 'String',
    },
    description: {
      type: 'String',
    },
    image: {
      type: 'Object',
      subtype: 'image',
    },
    link: {
      type: 'String',
    },
    href: {
      type: 'String',
    },
  },
};

export default {
  components: {
    HowItWorksHero,
    HowItWorksStatement,
    HowItWorksSection,
    HowItWorksFooter,
    HowItWorksNote,
  },
  mixins: [useCanonicalHead()],
  asyncData({ route }) {
    return loadPageData({ schema, $route: route }, () => routes.howItWorks, () => route.params.id);
  },
  data() {
    return {
      meta: {},
      hero: null,
      statement: null,
      sections: [],
      footer: null,
    };
  },
  head() {
    return {
      title: this.meta.title,
      meta: [
        { hid: 'description', name: 'description', content: this.meta.description },
        { property: 'og:title', content: this.meta.title },
        { property: 'og:description', content: this.meta.description },
        { property: 'og:url', content: `${headMeta.domain}${routes.howItWorks}/${this.$route.params.id}` },
        { property: 'og:site_name', content: headMeta.siteName },
        { property: 'og:type', content: headMeta.type },
        { property: 'og:image', content: this.hero.image.url },
      ],
    };
  },
  computed: {
    currentProvince() {
      return this.$store.state[UserSelectionStoreName].currentProvince;
    },
    provinceSections() {
      return this.sections.filter(
        (section) => [ALL_PROVINCES_VIEW, this.currentProvince].includes(section.province),
      );
    },
    pageType() {
      return this.$route.params.id;
    },
    colorScheme() {
      return HeroColorScheme[this.pageType];
    },
    heroSectionTrackEvent() {
      return HeroSectionEvent[this.pageType];
    },
  },
  methods: {
    images(items) {
      return items.map((item) => item.image);
    },
    attachments(section) {
      // TODO: When adding Ontario we need to add section.attachment_4
      return [section.attachment, section.attachment_2, section.attachment_3]
        .filter((attachment) => attachment.url
          && (attachment.name.includes(this.currentProvince)
            || this.$route.path === routes.howItWorksBuyer
            || this.$route.path === routes.howItWorksBuilder));
    },
  },
};
